export default __webpack_public_path__ + "static/media/sponsor2.f5ab80c6.png";